import {
  USER_REGISTER,
  USER_REGISTER_CANCELED,
  USER_REGISTER_ERROR,
  USER_REGISTER_FULFILLED,
  USER_REGISTER_INITIAL_STATE,
} from '../actions/RegisterActions'

export default (state = USER_REGISTER_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case USER_REGISTER: {
      return state
    }
    case USER_REGISTER_CANCELED: {
      return { ...USER_REGISTER_INITIAL_STATE }
    }
    case USER_REGISTER_ERROR: {
      return { ...state, ...action.payload }
    }
    case USER_REGISTER_FULFILLED: {
      return action.payload
    }
    default:
  }
  return state
}
